import { useEffect, useState } from 'react'

import { isObjectEmpty } from 'helpers/object'

import { getProgressColor } from '../utils/colors'

const MAX_DURATION = 180 // sec

const useTalktimePercentage = ({ userId, isTeacher, ttmMsg }) => {
    const [percentage, setPercentage] = useState(0)

    useEffect(() => {
        if (isObjectEmpty(ttmMsg) || !userId) return

        let percent = 0

        if (isTeacher) {
            const ttmData = ttmMsg.message?.teacher

            if (isObjectEmpty(ttmData)) return

            percent = parseInt(ttmData.activity)
        } else {
            const ttmData = ttmMsg.message?.students

            const data = ttmData?.find(data => data.user_id === userId)

            if (isObjectEmpty(data)) return

            percent = parseInt(data.activity)
        }

        setPercentage(percent)
    }, [ttmMsg, userId])

    return { percentage, color: getProgressColor(percentage) }
}

export default useTalktimePercentage
